import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';

const Footer = () => {
  const { t } = useLang();

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <Link to="/"><img src="/logo-matrix.png" alt="Matrix Electronic Devices by Maher" className="footer__logo" /></Link>
          <p>{t('footer_desc')}</p>
          <div className="footer__social">
            {['F', 'IG', 'YT', 'TK'].map(s => <button key={s} className="social-link">{s}</button>)}
          </div>
        </div>

        <div className="footer__links">
          <div className="footer__col">
            <h4>{t('footer_products')}</h4>
            <Link to="/category/earphones">{t('nav_earphones')}</Link>
            <Link to="/category/speakers">{t('footer_speakers')}</Link>
            <Link to="/category/phone-cases">{t('nav_phone_cases')}</Link>
            <Link to="/category/glass">{t('footer_glass')}</Link>
            <Link to="/category/gaming-accessories">{t('nav_gaming_accessories')}</Link>
            <Link to="/category/playstation">{t('footer_ps')}</Link>
          </div>
          <div className="footer__col">
            <h4>{t('footer_service')}</h4>
            <Link to="/contact">{t('footer_track')}</Link>
            <Link to="/legal/retours">{t('footer_returns')}</Link>
            <Link to="/legal/cgv">{t('footer_warranty')}</Link>
            <Link to="/contact">{t('footer_contact')}</Link>
          </div>
          <div className="footer__col">
            <h4>{t('footer_company')}</h4>
            <Link to="/about">{t('footer_about')}</Link>
            <Link to="/contact">{t('footer_careers')}</Link>
            <Link to="/about">{t('footer_blog')}</Link>
            <Link to="/legal/confidentialite">{t('footer_privacy')}</Link>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <p>{t('footer_copy')}</p>
        <div className="payment-icons">
          {['VISA', 'MC', 'AMEX', 'PayPal'].map(p => <span key={p} className="payment-badge">{p}</span>)}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
